import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import EditarEstudanteLayer from "../components/EditarEstudanteLayer";
import { useTranslation } from "../i18n/I18nContext";

const EditarEstudantePage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("estudante.breadcrumb.edit")} />
      <EditarEstudanteLayer />
    </MasterLayout>
  );
};

export default EditarEstudantePage;
